module.exports = __webpack_public_path__ + "MU.png?3b57dcb0ab002de960b0c6d07149ceab";